import { TOGGLE_NAV, TOGGLE_NAV_RESIZE, INITIAL_NAV } from '../_actions/types';
const defaultState = {}

export default function (state = defaultState, action) {
  switch (action.type) {
    case TOGGLE_NAV:
      return {...state, navOpen: action.payload}
    case TOGGLE_NAV_RESIZE:
      return {...state, navOpen: action.navOpen, smallWindow: action.smallWindow }
    case INITIAL_NAV:
      return { ...state, navOpen: action.navOpen, smallWindow: action.smallWindow }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/common/common_reducer.js